import { render, staticRenderFns } from "./ObiModal.vue?vue&type=template&id=b8991370&scoped=true&"
import script from "./ObiModal.vue?vue&type=script&lang=js&"
export * from "./ObiModal.vue?vue&type=script&lang=js&"
import style0 from "./ObiModal.vue?vue&type=style&index=0&id=b8991370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8991370",
  null
  
)

export default component.exports